(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    // `toggle` does not bubble, so we delegate on `click` (which does) and read
  // the post-toggle state on the next frame. Delegation keeps this working for
  // accordions injected by the theme editor.
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.accordion[data-single-open] summary');
    if (!summary) return;

    const current = summary.closest('details');
    const group = summary.closest('.accordion[data-single-open]');
    if (!current || !group) return;

    requestAnimationFrame(() => {
      if (!current.open) return;
      group.querySelectorAll('details[open]').forEach((item) => {
        if (item !== current) item.open = false;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-comparison"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.image-comparison').forEach((el) => {
    el.querySelector('.image-comparison__range').addEventListener('input', (e) => {
      el.style.setProperty('--position', e.target.value + '%');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    var SELECTOR = '.image-block__img';

    function reveal(img) {
      img.classList.add('is-loaded');
    }

    // `load` doesn't bubble, so listen in the capture phase. This catches
    // images that finish loading after this runs — including blocks the theme
    // editor injects mid-session, which the theme's own init misses.
    document.addEventListener(
      'load',
      function (event) {
        var img = event.target;
        if (img.tagName === 'IMG' && img.matches(SELECTOR)) reveal(img);
      },
      true
    );

    // Reveal images that were already complete (e.g. cached) before the
    // capture listener existed.
    function revealComplete(root) {
      (root || document).querySelectorAll(SELECTOR).forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) reveal(img);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        revealComplete();
      });
    } else {
      revealComplete();
    }

    // Re-check when the theme editor re-renders a section.
    document.addEventListener('shopify:section:load', function (event) {
      revealComplete(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video-hover-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.video-block').forEach((media) => {
    const video = media.querySelector('video');
    if (!video) return;

    media.addEventListener('pointerenter', () => video.play());
    media.addEventListener('pointerleave', () => video.pause());
    media.addEventListener('focusin', () => video.play());
    media.addEventListener('focusout', () => video.pause());
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    // Delegated so it also works for blocks injected by the theme editor.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-deferred-play]');
    if (!trigger) return;

    const frame = trigger.closest('.video-block__frame');
    const template = frame && frame.querySelector('.video-block__deferred');
    if (!template) return;

    const media = template.content.cloneNode(true);
    trigger.replaceWith(media);
    template.remove();

    const video = frame.querySelector('video');
    if (video) {
      video.play().catch(() => {});
    }
  });

  // Play on hover (desktop) / play while in viewport (mobile & touch).
  (function () {
    const HOVER = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    let observer = null;

    function getObserver() {
      if (observer || !('IntersectionObserver' in window)) return observer;
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const v = entry.target;
          if (entry.isIntersecting) v.play().catch(() => {});
          else v.pause();
        });
      }, { threshold: 0.35 });
      return observer;
    }

    function setup(root) {
      (root || document).querySelectorAll('.video-block__media--hover').forEach((v) => {
        if (v.dataset.hoverInit) return;
        v.dataset.hoverInit = '1';

        if (HOVER) {
          const play = () => v.play().catch(() => {});
          const stop = () => { v.pause(); v.currentTime = 0; };
          v.addEventListener('pointerenter', play);
          v.addEventListener('pointerleave', stop);
          v.addEventListener('focusin', play);
          v.addEventListener('focusout', stop);
        } else {
          const obs = getObserver();
          if (obs) obs.observe(v);
          else v.play().catch(() => {}); // no IO support: fall back to playing
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => setup());
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["visual-media"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-play-on-hover]').forEach((wrap) => {
    const video = wrap.querySelector('video');
    if (!video) return;

    wrap.addEventListener('pointerenter', () => video.play());
    wrap.addEventListener('pointerleave', () => { video.pause(); video.currentTime = 0; });
    wrap.addEventListener('focusin', () => video.play());
    wrap.addEventListener('focusout', () => { video.pause(); video.currentTime = 0; });
  });

  document.querySelectorAll('[data-video-player]').forEach((player) => {
    const video = player.querySelector('video');
    const btn = player.querySelector('[data-play-toggle]');
    if (!video || !btn) return;

    btn.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });

    video.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });

    video.addEventListener('play', () => {
      player.setAttribute('data-state', 'playing');
    });
    video.addEventListener('pause', () => {
      player.setAttribute('data-state', 'paused');
    });
    video.addEventListener('ended', () => {
      player.setAttribute('data-state', 'paused');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
